/**
 * Public admissions apply route (issue #9; form extracted to `<ApplyForm>` in #17).
 *
 * A thin `AuthCard` wrapper around the shared `<ApplyForm>` — the same form the
 * public landing REQUEST section renders. No `AppShell`/auth wrapper (a public
 * route, like `/sign-in`): the tenant is resolved server-side from the trusted
 * Origin, exactly like the pre-auth `GET /tenant` branding call `SignInPage`
 * makes. No account is created and no payment is collected.
 */
import { ApplyForm } from "@/components/apply/ApplyForm";
import { AuthCard } from "@/components/auth/AuthCard";
import { ExternalRedirect } from "@/components/ExternalRedirect";
import { useTenantPresentation } from "@/hooks/use-tenant-presentation";

export function ApplyPage() {
  // Public branding via the centralized hook — the same best-effort GET /tenant
  // read SignInPage makes; a localhost/no-tenant Origin in dev just falls back to
  // the AuthCard defaults, never blocking the form, and never calls /tenant/me.
  const { name, logoUrl, content } = useTenantPresentation();

  if (content.admissions.kind === "external") {
    return <ExternalRedirect to={content.admissions.url} />;
  }

  const { application } = content.admissions;

  return (
    <AuthCard
      brandName={name}
      logoUrl={logoUrl}
      subtitle={application.subtitle}
      eyebrow={application.eyebrow}
      heading={application.heading}
      lede={application.lede}
    >
      <ApplyForm
        applicantRoleLabel="I am applying as"
        contactEmail={content.footer.email}
        notePlaceholder={application.notePlaceholder}
        phoneHint={null}
        phoneRequired
        showBackToSignIn
        showProgram={false}
        submitLabel="Submit application"
        submissionNoun="application"
        successHeading="Application received."
        successLead={application.successLead}
      />
    </AuthCard>
  );
}
